<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsDirectoryService.showDetailedView"
         [ngStyle]="{width: settingsDirectoryService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Corporation'"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsDirectory'" [ngClass]="{'sk-loading': settingsDirectoryService.spinnerShow}">
                    <corporations-list></corporations-list>
                    <spinner [spinnerShow]="settingsDirectoryService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsDirectoryService.data.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsDirectoryService.data.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <settings-directory-detailed-view></settings-directory-detailed-view>
    </div>
</div>
<directory-reminders-modal *ngIf="settingsDirectoryService.isRemindersModalShow"></directory-reminders-modal>
<notification-modal *ngIf="settingsDirectoryService.isNotificationModalShow"></notification-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/settings-directory.component.html